

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import {AxiosResponse} from 'axios';
import VueAxios from 'vue-axios';
import { EnergyDisplay } from '../interfaces';
import { BASE_BACKEND_URL } from '../main';

interface IDocument {
    id: number;
    type: string;
    name: string;
    svgicon: string;
    icon_colour: string;
    border_colour: string;
    order: number;
    extension?: string;
    url?: string;
    build_phase?: string;
    tenancy_type?: string;
}

interface IDocumentParent {
    name: string;
    description: string;
    documents: IDocument[];
}

interface IRootDocuments {
    documents: IDocument[];
}

@Component({
    components: {},
})
export default class Documents extends Vue {
    private documents: IDocument[] = [];
    private current_name: string = '';
    private current_description: string = '';

    @Watch('$route', { immediate: true, deep: true })
    public onQueryChanged(value: string, oldValue: string) {
        this.setup();
    }

    public async setup() {

        const self = this;
        let folder_id = null;

        if ('folder_id' in this.$route.query) {
            folder_id = this.$route.query.folder_id;
        }

        let file_id = null;

        if ('file_id' in this.$route.query) {
            file_id = this.$route.query.file_id;
        }

        if ((folder_id === null || folder_id === undefined) && (file_id === null || file_id === undefined)) {
            folder_id = '0'; // Show Root folder

            this.documents = await this.fetchDocumentsForRoot();

            this.documents = this.documents.sort(
                (i1, i2) => i1.order - i2.order,
            );

            // Set default svgicon
            for (const d of this.documents) {
                if (!d['svgicon']) {
                    d['svgicon'] =
                        'M16,15H9V13H16V15M19,11H9V9H19V11M19,7H9V5H19V7M3,5V21H19V23H3C1.9,23 1,22.1 1,21V5H3M21,1C22.1,1 23,1.9 23,3V17C23,18.11 22.11,19 21,19H7C5.9,19 5,18.1 5,17V3C5,1.89 5.89,1 7,1H21M7,3V17H21V3H7Z';
                }
            }

            return;
        }

        if (file_id !== null && file_id !== undefined && typeof file_id === 'string') {
            self.$router.push({ name: 'document', params: { file_id } });
            return;
        }

        if (folder_id !== null && folder_id !== undefined && typeof folder_id === 'string') {
            const document_json: IDocumentParent = await this.fetchDocuments(folder_id);
            this.current_name = document_json['name'];
            this.current_description = document_json['description'];
            this.documents = document_json['documents'];

            this.documents = this.documents.sort(
                (i1, i2) => i1.order - i2.order,
            );

            for (const d of this.documents) {
                if (!d['svgicon']) {
                    d['svgicon'] =
                        'M16,15H9V13H16V15M19,11H9V9H19V11M19,7H9V5H19V7M3,5V21H19V23H3C1.9,23 1,22.1 1,21V5H3M21,1C22.1,1 23,1.9 23,3V17C23,18.11 22.11,19 21,19H7C5.9,19 5,18.1 5,17V3C5,1.89 5.89,1 7,1H21M7,3V17H21V3H7Z';
                }
            }
        }

        return;
    }

    public async mounted() {
        this.setup();
    }

    private getUrlQueryLink(doc: IDocument): [string, string] {

        if (doc.type  === 'folder') {
            return  ['/#/documents?folder_id=' + doc.id, ''];
        } else {

            if (doc.extension  === 'html' || doc.extension === 'htm') {
                return  ['/#/document/' + doc.id, ''];
            }

            return [BASE_BACKEND_URL + doc.url || '/', '_blank'];
        }
    }

    private async fetchDocumentsForRoot(): Promise<IDocument[]> {
        const self = this;

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Token ' + self.$store.getters.Jwt,
        };

        return await axios.request<IRootDocuments>({
            method: 'GET',
            headers: headers,
            url: 'https://shimmyplus-default-backend.carnegosystems.net/documents/rest/get_shimmy_documents_id_titles_root_display/',
        })
        .then((response: AxiosResponse<IRootDocuments>) => {
            return response.data.documents;
        }).catch((error) => {
            console.log(error);
            return [];
        });
    }

    private async fetchDocuments(section_id: string): Promise<IDocumentParent> {
        const self = this;

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Token ' + self.$store.getters.Jwt,
        };

        return await axios.request<IDocumentParent>({
            method: 'GET',
            headers: headers,
            url: 'https://shimmyplus-default-backend.carnegosystems.net/documents/rest/get_shimmy_documents_id_titles/' + section_id,
        })
        .then((response: AxiosResponse<IDocumentParent>) => {
            return response.data;
        }).catch((error) => {
            console.log(error);
            return {name: 'unknown', description: 'unknown', documents: []};
        });
    }
}
